import { Draft } from '@/types';
import { httpService } from '@/utils';

async function getDrafts(assignmentId: string): Promise<Draft[]> {
  return await httpService.get<Draft[]>(`/drafts/assignment/${assignmentId}`);
}

async function createDraft(assignmentId: string): Promise<Draft> {
  return await httpService.post<Draft>(`/drafts/assignment/${assignmentId}`);
}

async function updateDraft(draftId: string, draftData: string): Promise<Draft> {
  return await httpService.patch<Draft>(`/drafts/${draftId}`, {
    draft_data: draftData,
  });
}

export const draftService = {
  getDrafts,
  createDraft,
  updateDraft,
};
